import React, { useId } from 'react';

const AdirePattern = ({ className = '', color = 'currentColor', opacity }) => {
  const patternId = `adire-${useId().replace(/:/g, '')}`;

  return (
    <svg
      className={className}
      viewBox="0 0 600 600"
      preserveAspectRatio="none"
      aria-hidden="true"
      style={{ color, opacity }}
    >
      <defs>
        <pattern id={patternId} x="0" y="0" width="96" height="96" patternUnits="userSpaceOnUse">
          <path d="M24 12v24M12 24h24M72 60v24M60 72h24" stroke="currentColor" strokeWidth="1.4" fill="none" strokeLinecap="round" />
          <circle cx="72" cy="24" r="3" fill="currentColor" />
          <circle cx="24" cy="72" r="3" fill="currentColor" />
          <rect x="43" y="43" width="10" height="10" fill="none" stroke="currentColor" strokeWidth="1.2" />
          <rect x="38" y="38" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="1" />
          <path d="M0 48h12M84 48h12M48 0v12M48 84v12" stroke="currentColor" strokeWidth="1" fill="none" strokeLinecap="round" />
        </pattern>
      </defs>
      <rect width="600" height="600" fill={`url(#${patternId})`} />
    </svg>
  );
};

export default AdirePattern;
